import { MailReceivedFromDTO } from "../../models/mail-received-from/mail-received-from-dto";
import { MailReceivedFromSTO } from "../../models/mail-received-from/mail-received-from-sto";
import { BaseApiService } from "../base";

export class MailReceivedFromApiService extends BaseApiService<MailReceivedFromDTO, MailReceivedFromSTO> {
  constructor() {
    super({
      servicePath: "/MailreceivedFrom",
      loadItemsPath: "/GetMailreceivedFrom",
      saveItemsPath: "/SaveMailReceivedFrom",
    });
  }
}
